// "Meine Exporte" als eigene Seite (L13-01a, ST-SEA-002 F2): die Liste der
// eigenen Exporte aus Kontaktliste und Sammlungen, erreichbar ueber das
// Kontomenue und den Link der Meldung nach dem Anlegen. Die h1 traegt der
// Rahmen ("Meine Exporte"), hier steht nur die Karte.

import type { ReactElement } from 'react';
import { Card } from '@fluentui/react-components';

import { useScreenStyles } from '../shell/screen-styles.ts';
import { MeineExporteListe, useMeineExporte } from './kontakte-export.tsx';

export interface MeineExporteScreenProps {
  readonly apiBaseUrl: string;
  readonly accessToken: () => Promise<string | undefined>;
  readonly onReauthenticate: () => void;
}

export function MeineExporteScreen(props: MeineExporteScreenProps): ReactElement {
  const styles = useScreenStyles();
  const exporte = useMeineExporte(props, true, true);
  return (
    <Card className={styles.card}>
      <MeineExporteListe {...props} exporte={exporte} />
    </Card>
  );
}
